define("settings/components/cancel-plan/modal/success", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@onClose}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header
        @title={{if
          this.hasActiveTrial
          (t "account.change_plan.cancellation_feedback.success_trial" planName=this.planName)
          (t "account.change_plan.cancellation_feedback.success" planName=this.planName)
        }}
      />
      <modal.card-body>
        <p>
          {{#if this.hasActiveTrial}}
            {{t
              "account.change_plan.cancellation_feedback.thanks_trial"
              activeUntil=this.activeUntil
              planName=this.planName
            }}
          {{else}}
            {{t "account.change_plan.cancellation_feedback.thanks" activeUntil=this.activeUntil planName=this.planName}}
          {{/if}}
        </p>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @onClick={{@onClose}}
          @size="regular"
          @text={{t "shared_words.done"}}
          @variant="outline"
          class="u--float--right"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "GQ4U+h3k",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[52,[30,0,[\"hasActiveTrial\"]],[28,[37,2],[\"account.change_plan.cancellation_feedback.success_trial\"],[[\"planName\"],[[30,0,[\"planName\"]]]]],[28,[37,2],[\"account.change_plan.cancellation_feedback.success\"],[[\"planName\"],[[30,0,[\"planName\"]]]]]]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,\"\\n\"],[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"          \"],[1,[28,[35,2],[\"account.change_plan.cancellation_feedback.thanks_trial\"],[[\"activeUntil\",\"planName\"],[[30,0,[\"activeUntil\"]],[30,0,[\"planName\"]]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,2],[\"account.change_plan.cancellation_feedback.thanks\"],[[\"activeUntil\",\"planName\"],[[30,0,[\"activeUntil\"]],[30,0,[\"planName\"]]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,3],[[24,0,\"u--float--right\"]],[[\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[30,1],\"regular\",[28,[37,2],[\"shared_words.done\"],null],\"outline\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@onClose\",\"modal\"],false,[\"shared/modal\",\"if\",\"t\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/cancel-plan/modal/success.hbs",
    "isStrictMode": false
  });
  let SuccessComponent = _exports.default = (_class = class SuccessComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "subscriptions", _descriptor, this);
    }
    get activeUntil() {
      return this.subscription.activeUntil;
    }
    get hasActiveTrial() {
      return this.subscriptions.hasActiveTrial;
    }
    get subscription() {
      return this.subscriptions.subscription;
    }
    get planName() {
      return this.subscription.name;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SuccessComponent);
});